<template>
  <div ref="classify" class="classify">
    <div class="tag type" :style="{ width: leftWidth + 'px' }">
      {{ classify.name }}
    </div>
    <div class="items">
      <template v-for="(item, index) in classify.children">
        <span
          :id="classify.id + '_' + item.id"
          :data-index="index"
          class="tag item"
          :class="{ current: value.item == item.id }"
          :key="item.id"
          @click="onTagClick(item.id, index, $event)"
        >
          {{ item.name }}
        </span>
        <div
          class="child-container"
          :id="'child_' + classify.id + '_' + item.id"
          :key="'child_' + classify.id + '_' + item.id"
          v-show="false"
        ></div>
      </template>
      <div
        :id="classify.id + '_child'"
        class="child"
        v-show="children.length > 1"
      >
        <span
          class="tag child"
          :class="child.id === value.child ? 'current' : ''"
          v-for="child in children"
          :key="child.id"
          @click.stop="changeChild(child.id)"
        >
          {{ child.name }}
        </span>
        <div class="arrow" :style="{ left: left + 'px' }"></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "ClassifyItem",
  props: {
    classify: {
      type: Object,
      default: () => {
        return {};
      },
    },
    value: {},
    leftWidth: {
      type: Number,
      default: 28,
    },
  },
  watch: {
    classify() {
      this.init();
    },
    $route() {
      if (!this.$refs.classify) {
        return;
      }
      this.$refs.classify.querySelectorAll(".child-container").forEach(ele => {
        ele.style.display = "none";
      });
    },
  },
  computed: {
    children() {
      let item = this.classify.children.filter(
        item => item.id == this.value.item,
      )[0];
      if (!item) {
        return [];
      }
      return item.children || item.child || [];
    },
  },
  data() {
    return {
      left: 0,
      classifyElement: {},
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    async init() {
      await this.$nextTick();
      if (!this.$refs.classify) {
        return;
      }
      let itemElements = this.$refs.classify
        .querySelector(".items")
        .querySelectorAll(".tag.item");
      itemElements = [].slice.call(itemElements);
      if (itemElements.length == 0) {
        return;
      }
      let firstLeft = itemElements[0].offsetLeft;
      let rowFirstElements = itemElements.filter(
        ele => ele.offsetLeft == firstLeft,
      );
      if (rowFirstElements.length <= 1) {
        return;
      }
      let lastRowFirstIndex =
        rowFirstElements[rowFirstElements.length - 1].dataset["index"];
      itemElements.forEach((ele, index) => {
        if (index >= lastRowFirstIndex) {
          return;
        }
        ele.classList.add("tag-merge");
      });
    },
    triggerEvent(item, child) {
      let value = { ...this.value };
      if (item !== undefined) {
        value.item = item;
      }
      if (child !== undefined) {
        value.child = child;
      }
      this.$emit("change", {
        id: this.classify.id,
        value: value,
      });
    },
    onTagClick(value, index, event) {
      let itemElements = this.$refs.classify
        .querySelector(".items")
        .querySelectorAll(".tag.item");
      let maxIndex;
      itemElements.forEach(el => {
        this.classifyElement[el.dataset["index"]] = {
          id: el.id,
          isFirst: el.offsetLeft == itemElements[0].offsetLeft,
        };
        maxIndex = el.dataset["index"];
      });
      let left =
        event.currentTarget.offsetLeft -
        parseInt(
          (document.documentElement.clientWidth - 1200) / 2 -
            event.currentTarget.clientWidth / 2,
        ) -
        this.leftWidth -
        24 -
        32;
      this.left = left;
      let appendId;
      for (let key in this.classifyElement) {
        if (key <= index) {
          continue;
        }
        if (this.classifyElement[key].isFirst) {
          appendId = this.classifyElement[key - 1].id;
          break;
        }
      }
      if (!appendId) {
        appendId = this.classifyElement[maxIndex].id;
      }
      appendId = "child_" + appendId;
      this.$refs.classify.querySelectorAll(".child-container").forEach(ele => {
        ele.style.display = "none";
      });
      let appendEle = document.getElementById(appendId);
      if (appendEle) {
        let child = document.getElementById(this.classify.id + "_" + "child");
        if (child) {
          appendEle.appendChild(child.cloneNode(true));
          appendEle.style.display = "block";
        }
      }

      this.triggerEvent(value, 0);
    },
    changeChild(id) {
      this.triggerEvent(undefined, id);
    },
  },
};
</script>
<style lang="scss" scoped>
.classify {
  display: flex;
}
.tag {
  height: 24px;
  border-radius: 5px;
  padding: 0 11px;
  font-size: 14px;
  color: #333333;
  line-height: 24px;
  cursor: pointer;
  margin: 0 22px 20px 0;
  display: inline-block;

  &.type {
    color: #999999;
    cursor: default;
    padding: 0;
    margin-right: 13px;
    flex-shrink: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    &:hover {
      background-color: transparent;
    }
  }

  &.current {
    background-color: $primary-color !important;
    color: white;

    &:hover {
      color: white;
    }
  }

  &:hover {
    background-color: rgba($color: $primary-color, $alpha: 0.1);
    color: $primary-color;
  }
}

.tag-merge {
  margin-bottom: 12px;
}
</style>
